export default __webpack_public_path__ + "locales/de/PeopleTranslations.json?hash=5391ff05f3d04be0a6433bb8dfb393d2";